// extracted by mini-css-extract-plugin
module.exports = {"content":"content__16Dgj","row__field":"row__field__21YPo","row__label":"row__label__1xL_T","row__label__descr":"row__label__descr__2yTWg"};